import { render, staticRenderFns } from "./FinixTermsAndConditions.vue?vue&type=template&id=ea0ddbb6&"
import script from "./FinixTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./FinixTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./FinixTermsAndConditions.vue?vue&type=style&index=0&id=ea0ddbb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports